export const defaultDeviceLogBookSorted = [{ dataField: "Date", order: "desc" }];

export const defaultDeviceAccessoriesSorted = [{ dataField: "DeliveryDate", order: "desc" }];
